export default {
  PAYLATER: 1,
  PURCHASEORDER: 2,
  CREDITCARD: 3,
};
